import { render, staticRenderFns } from "./area_ntzz.vue?vue&type=template&id=054fe2d4&scoped=true"
import script from "./area_ntzz.vue?vue&type=script&lang=js"
export * from "./area_ntzz.vue?vue&type=script&lang=js"
import style0 from "./area_ntzz.vue?vue&type=style&index=0&id=054fe2d4&prod&lang=less"
import style1 from "./area_ntzz.vue?vue&type=style&index=1&id=054fe2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fe2d4",
  null
  
)

export default component.exports